import { Route, Routes } from "react-router-dom";

import TutoringRedirect from "./TutoringRedirect";
import TutoringSubjectsPage from "./Subjects";

export const TutoringRoutes = () => (
  <Routes>
    <Route index element={<TutoringRedirect />} />
    <Route path="/:subjectSlug" element={<TutoringSubjectsPage />} />
  </Routes>
);
